import { render, staticRenderFns } from "./integration-cases.vue?vue&type=template&id=f95636da&"
import script from "./integration-cases.vue?vue&type=script&lang=js&"
export * from "./integration-cases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports